import './emergency-contact-form.styles.scss';
import FormField from '../form-field/form-field.component';
import { Stack } from '@mui/material';

const EmergencyContactForm = ({ emergencyContact, onChange, errors }) => {
  const { fullName, phone } = emergencyContact;

  const handleChange = (event) => {
    const { name, value } = event.target;
    onChange({ ...emergencyContact, [name]: value });
  };

  const getErrorMessage = (fieldName) => {
    return !!errors ? errors[fieldName] : null;
  };

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
      <FormField
        label="Nome completo"
        name="fullName"
        variant="light"
        required
        onChange={handleChange}
        value={fullName}
        errorMessage={getErrorMessage('fullName')}
      />
      <FormField
        label="Telefone"
        name="phone"
        variant="light"
        required
        onChange={handleChange}
        value={phone}
        mask="(99) 99999-9999"
        errorMessage={getErrorMessage('phone')}
      />
    </Stack>
  );
};

export default EmergencyContactForm;
